import colors from 'components/apps/FinanceAccounts/Charts/colors'

const transType = {
  EXPENSE: 1,
  PURCHASE_ORDER: 2,
  PURCHASE_INVOICE: 3,
  QUOTE: 4,
  INVOICE: 5,
  ORDER: 6,
  DELIVERY: 7,
  RETURN: 9,
  SPEND_MONEY: 11,
  RECEIVE_MONEY: 12,
  SEND_TRANSFER: 13,
  RECEIVE_TRANSFER: 14,
  EXPENSE_PAYMENT: 15,
  PURCHASE_PAYMENT: 16,
  RECEIVE_INVOICE_PAYMENT: 17,
  BANK_REVERSAL: 18,
  BANK_OPENING_BALANCE: 19,
  REGISTER_FIXED_ASSET: 20,
  BANK_MANUAL_JOURNAL: 32,
  REVERSAL: 21,
  OPENING_BALANCE: 22,
  RECEIVE_SALES_ORDER_PAYMENT: 23,
  CREDIT_MEMO_PAYMENT: 24,
  DEBIT_MEMO_PAYMENT: 25,
  BANK_CREDIT_MEMO: 26,
  BANK_DEBIT_MEMO: 27,
  PURCHASE_ORDER_PAYMENT: 28,
  PAYMENT_RECAP: 29,
  MANUAL_JOURNAL: 31,
  INVOICE_WITHOLDING: 33,
  PURCHASE_INVOICE_WITHOLDING: 34,
  CREATE_FIXED_ASSET: 41,
  INITIAL_DEPRECIATION: 42,
  DEPRECIATION: 43,
  DISPOSAL: 44,
  WAREHOUSE_TRANSFER: 51,
  STOCK_ADJUSTMENT: 52,
  PRODUCT_CONVERSION: 53,
  CREDIT_MEMO: 61,
  DEBIT_MEMO: 62,
  PURCHASE_QUOTE: 63,
  PURCHASE_DELIVERY: 8,
  PURCHASE_RETURN: 64,
  CLOSING: 71,
  PROFORMA_INVOICE: 98,
  JOIN_PURCHASE_INVOICE: 240,
  PURCHASE_JOIN_INVOICE_PAYMENT: 241,
  JOIN_INVOICE: 250,
  RECEIVE_JOIN_INVOICE_PAYMENT: 251,
  USER: 1001,
  TRANSLATION: 1002,
  ROLE: 1003,
  OPTION: 1005,
  WAREHOUSE: 1006,
  TERM: 1007,
  TAX: 1008,
  PRODUCT: 1009,
  PRODUCT_CATEGORY: 1010,
  NUMBER: 1011,
  LAYOUT_INVOICE: 1012,
  FIXED_ASSET: 1013,
  CONVERSION_BALANCE: 1014,
  CONTACT: 1015,
  GROUP_CONTACT: 1020,
  ACCOUNT: 1017,
  BILLING: 1019,
  BANK_STATEMENT: 1016,
  CASH_BANK: 1100,
  RECURRING_INVOICE: 1101,
  RECURRING_ORDER: 1102,
  RECURRING_PURCHASEINVOICE: 1103,
  RECURRING_PURCHASEORDER: 1104,
  RECURRING_EXPENSE: 1105,
  RECURRING_MANUALJOURNAL: 1106,
  RECURRING_CASHBANK: 1107,
  TAG: 1108,
  INVOICE_PAYMENT_CREDIT_MEMO: 81,
  PURCHASE_INVOICE_PAYMENT_DEBIT_MEMO: 82,
  UNREALIZED_GAIN: 73,
  SALES_SHIPPING_COSTS: 85,
  PURCHASE_SHIPPING_COSTS: 86,
  // transType from FE
  REPORT_SALES_PER_SALES_PERSON: 'REPORT_SALES_PER_SALES_PERSON',
  SCHEDULER_LOCK_DATE: 1042,
}

const dbFormat = 'YYYY-MM-DD'
const paymentConst = {
  UNPAID: 1,
  PARTIAL: 2,
  PAID: 3,
}

const bankTransStatus = {
  RECONCILED: 32,
  UNRECONCILED: 31,
  VOID: 113,
  WAITING: 111,
  REJECT: 112,
}

const statusColors = [
  { id: transType.UNRECONCILED, color: '#CF2A28' },
  { id: transType.RECONCILED, color: '#11A428' },
  { id: paymentConst.UNPAID, name: 'Unpaid', color: '#CF2A28' },
  { id: paymentConst.PARTIAL, name: 'Partial', color: '#EB9234' },
  { id: paymentConst.PAID, name: 'Paid', color: '#11A428' },
  { id: bankTransStatus.VOID, name: 'Void', color: '#ADC2D0' },
]

const permissions = {
  INVOICES_ADD: 'invoices_add',
  INVOICES_EDIT: 'invoices_edit',
  INVOICES_DELETE: 'invoices_delete',
}

const productBundleType = {
  GENERAL: 0,
  PACKAGE: 1,
  MANUFACTURE: 2,
}

const everyType = {
  MONTH: 2,
  WEEK: 1,
  DAY: 3,
}

const availableTransType = [
  transType.INVOICE,
  transType.ORDER,
  transType.PURCHASE_INVOICE,
  transType.PURCHASE_ORDER,
  transType.EXPENSE,
  transType.MANUAL_JOURNAL,
  transType.CASH_BANK,
]

const fallbackImage =
  'data:image/png;base64,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'

const customColumnTypes = {
  TEXT: 1,
  NUMBER: 2,
  CURRENCY: 3,
  DATE: 4,
  OPTIONS: 5,
  CHECKLIST: 6,
}

const priceRuleTypes = {
  MIN_QT: 0,
  MIN_AMOUNT: 1,
}

// Default transaction penjualan dan pembelian
const defaultTransItem = {
  finance_account_id: undefined,
  qty: 1,
  price: 0,
  tax_id: '',
  desc: null,
  amount: 0,
  tax_manual: 0,
  discount_percent: 0,
  unit_id: undefined,
  product_units: [],
  stock: 0,
}

const productSerialNumberType = {
  UNIQUE_NUMBER: 1,
  PRODUCTION_NUMBER: 2,
}
const allowedLocales = ['en-US', 'id-ID']

const contactType = {
  1: {
    name: 'Vendor',
    color: colors[0],
  },
  2: {
    name: 'Employee',
    color: colors[2],
  },
  3: {
    name: 'Customer',
    color: colors[3],
  },
  4: {
    name: 'Other',
    color: colors[12],
  },
}

// Untuk keperluan QA. Supaya tidak harus buat 100.000 data
const LIMIT_AUTOMATIC_SHOW_GRAND_TOTAL = process.env.REACT_APP_LIMIT_AUTOMATIC_SHOW_GRAND_TOTAL
  ? parseInt(process.env.REACT_APP_LIMIT_AUTOMATIC_SHOW_GRAND_TOTAL, 10)
  : 100_000

// Untuk detect dimana saja yang di disable, mengurangi kesalahan enable fiturnya kembali
const ENABLED_TAG_OWNER_ONLY = false

const PAYMENT_TYPE = {
  CASH: '94ec89a4-5c56-4fc6-b0ed-92030953d2af',
  E_WALLET: 'ed35c837-8321-4e57-ae58-d51e64c48537',
  ONLINE_DEVERY: 'd2aec07c-2eb6-4cab-9b9c-4542a3b8ff84',
  EDC: '9de6cc9e-25f4-413f-83d4-a6de6be9dc04',
  E_COMMERCE: '9d8f1d5d-bdf2-480e-95de-60c8eb0c4bff',
  OTHER: '0b688e8a-5ca6-486b-849e-583dda17aebd',
  TRANSFER_BANK: '17610b60-19cb-4ff6-b822-02d1ff19e75a',
  DEPOSIT: '92f80bd5-7592-af65-188c-a27786514cca',
}

export {
  allowedLocales,
  contactType,
  transType,
  statusColors,
  dbFormat,
  paymentConst,
  permissions,
  productBundleType,
  everyType,
  availableTransType,
  bankTransStatus,
  fallbackImage,
  customColumnTypes,
  priceRuleTypes,
  defaultTransItem,
  productSerialNumberType,
  LIMIT_AUTOMATIC_SHOW_GRAND_TOTAL,
  PAYMENT_TYPE,
  ENABLED_TAG_OWNER_ONLY,
}
